import store from '../store';
class CampaignTimer {
  constructor() {
    this.campaignTimers = {};
    this.isInitialized = false;
  }

  initTimers = ({ campaigns }, websiteToken) => {
    // Only clear timers if we're not already initialized or if we have no active timers
    if (!this.isInitialized || Object.keys(this.campaignTimers).length === 0) {
      this.clearTimers();
      this.isInitialized = true;
    }

    // Sort campaigns by timeOnPage (ascending) to ensure they trigger in order
    const sortedCampaigns = [...campaigns].sort((a, b) => {
      // First sort by timeOnPage
      const timeComparison =
        parseInt(a.timeOnPage, 10) - parseInt(b.timeOnPage, 10);
      // If timeOnPage is equal, sort by id
      if (timeComparison === 0) {
        return a.id - b.id;
      }
      return timeComparison;
    });

    // Only set timers for campaigns that don't already have timers
    sortedCampaigns.forEach(campaign => {
      const { timeOnPage, id: campaignId } = campaign;

      // Skip if this campaign already has a timer
      if (this.campaignTimers[campaignId]) {
        return;
      }

      // Make sure timeOnPage is treated as a number
      const delay = parseInt(timeOnPage, 10) * 1000;

      this.campaignTimers[campaignId] = setTimeout(() => {
        // Check if this campaign has already been executed
        const state = store.state.campaign;
        const isExecuted = state.executedCampaignIds.includes(campaignId);

        if (!isExecuted) {
          store.dispatch('campaign/startCampaign', {
            campaignId,
            websiteToken,
          });
        }
      }, delay);
    });
  };

  clearTimers = () => {
    // Properly iterate through object keys
    Object.keys(this.campaignTimers).forEach(campaignId => {
      clearTimeout(this.campaignTimers[campaignId]);
    });
    // Reset to empty object
    this.campaignTimers = {};
    this.isInitialized = false;
  };
}
export default new CampaignTimer();
